import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import "./index.scss";
import CustomModal from "../../../../../../components/common/modal";
import Input from "../../../../../../components/common/FormFields/input";
import { useForm, useWatch } from "react-hook-form";
import Radio from "../../../../../../components/common/FormFields/radio";
import CustomSelect from "../../../../../../components/common/FormFields/select";
import Textarea from "../../../../../../components/common/FormFields/textarea";
import { useSelector } from "react-redux";
import axios from "axios";
import { campaigns, urlCode } from "./leadFormConstants";
import { getCodeFromUrl } from "../../../../../../utils/helper";
import { toast } from "react-toastify";
import CongratulationModal from "../congratulationModal";

function FormModal({ show, handleClose, modalData, fields }) {
  const {
    control,
    getValues,
    reset,
    handleSubmit,
    watch,
    setValue,
    formState: { errors, isValid },
  } = useForm({
    mode: "onChange",
  });
  const customerData = useSelector((state) => state.common.customerData);
  const [modalshow, setModalShow] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const [formData, setFormData] = useState(customerData);
  const agCode = getCodeFromUrl();
  const handleModalShow = () => {
    setModalShow(true);
    handleClose(true);
  };

  const handleModalClose = () => {
    setModalShow(false);
  };

  const handelFormChange = (e, name) => {
    setFormData((formData) => {
      console.log(e, name);
      let updateParam = { [name]: e.target.value };
      const data = { ...formData, ...updateParam };
      return data;
    });
  };

  const customFields = (data) => {
    const filteredData = data;
    let payload = {};

    fields.map((field) => {
      payload[field] = data[field];
    });
    console.log(payload, fields);
    return payload;
  };

  const onSubmit = (data) => {
    let payload = customFields(formData);
    const { name, contact, ...restData } = payload;

    let body = {
      name: name,
      phoneNumber: [
        {
          type: "MOBILE",
          code: "IN",
          value: contact,
          dialCode: "+91",
          primary: true,
        },
      ],
      campaign: campaigns[modalData?.form?.id],
      IMA: urlCode[agCode.toLowerCase()],
      source: null,
      customFieldValues: {
        ...restData,
      },
    };

    axios
      .post(`https://api.kylas.io/v1/leads/`, body, {
        headers: {
          "api-key": `${process.env.REACT_APP_LEAD_API_KEY}`,
        },
      })
      .then((res) => {
        if (res && res.status === 200) {
          handleModalShow();
        }
      })
      .catch((error) => {
        toast.error(`${error?.response?.data?.message}`, error);
      });
  };
  const watchFields = watch();
  useEffect(() => {
    const formValues = getValues();
    const allFieldsFilled = Object.values(formValues).every(
      (value) => value !== undefined && value !== null && value !== ""
    );

    setIsFormValid(allFieldsFilled);
  }, [watchFields, getValues]);

  useEffect(() => {
    reset(formData);
  }, []);

  return (
    <>
      <CustomModal
        show={show}
        handleClose={handleClose}
        // title={modalData?.header}
        headerClass="insurance-form-header"
      >
        <div className="form-modal-wrapper">
          <h4 className="form-head">{modalData?.header}</h4>
          <p className="insurance-form-desc">{modalData?.desc}</p>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <input
              name="id"
              className="invisible-label"
              value={modalData?.form?.id}
            ></input>
            {modalData?.form?.form?.forminputField?.forms?.map((item) => (
              <>
                <div className="input-container" key={item.id}>
                  {item.name === "remarks" && item.label != "Journey Date" && (
                    <Form.Label>
                      {item?.label} <span style={{ color: "red" }}>*</span>
                    </Form.Label>
                  )}

                  {/* <Form.Control
                  name={item?.name}
                  type={item?.type}
                  placeholder={item?.placeholder}
                  className="input-field"
                /> */}

                  {item.type != "radio" && item.type != "textarea" && (
                    <>
                      <Input
                        // required={false}
                        key={item?.id}
                        name={item?.name}
                        type={item?.type}
                        placeholder={item?.placeholder}
                        className="input-field"
                        control={control}
                        errors={errors}
                        // rules={{ required: true }}
                        onChange={(e) => handelFormChange(e, item.name)}
                        label={item.label}
                        value={
                          item?.name === "name"
                            ? formData?.name
                            : item?.name === "birth_date"
                            ? formData?.birth_date
                            : item?.name === "contact"
                            ? formData?.contact
                            : item?.name === "state"
                            ? formData?.state
                            : formData[item?.name]
                        }
                      />
                    </>
                  )}

                  {item.type === "radio" && (
                    <>
                      <div className="radio-button">
                        <Form.Check
                          inline
                          type={item?.type}
                          label={"Yes"}
                          id="yes"
                          value={true}
                          name={item?.name}
                          required
                          onChange={(e) => handelFormChange(e, item?.name)}
                        />
                        <Form.Check
                          inline
                          type={item?.type}
                          label={"No"}
                          id="no"
                          value={false}
                          name={item?.name}
                          onChange={(e) => handelFormChange(e, item?.name)}
                          required
                        />
                      </div>
                    </>
                    // <Radio
                    //   name={item?.name}
                    //   label={item?.label}
                    //   type={item?.type}
                    //   control={control}
                    //   errors={errors}
                    // />
                  )}
                  {/* {item.type === "select" && (
                  <CustomSelect
                    name={item?.name}
                    type={item?.type}
                    control={control}
                    errors={errors}
                    label={item?.label}
                  />
                )} */}
                  {item.type === "textarea" && (
                    <>
                      <Textarea
                        required
                        name={item?.name}
                        type={item?.type}
                        control={control}
                        errors={errors}
                        label={item?.label}
                        value={formData?.address}
                        onChange={(e) => handelFormChange(e, item.name)}
                      />
                    </>
                  )}
                  {/* {item.type === "date" && (
                  <Date
                    key={item?.id}
                    name={item?.name}
                    type={item?.type}
                    control={control}
                    errors={errors}
                    label={item?.label}
                    value={
                      item?.name === "Date Of Birth"
                        ? customerData.birth_date
                        : ""
                    }
                  />
                )} */}
                </div>
              </>
            ))}
            <div className="get-quotes-btn">
              <Button
                variant="primary"
                type="submit"
                // onClick={handleModalShow}
                // disabled={!isValid}
              >
                Get Quotes
              </Button>
            </div>
          </Form>
        </div>
      </CustomModal>
      <CongratulationModal show={modalshow} closeModal={handleModalClose} />
    </>
  );
}

export default FormModal;
